import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'

import { AddHotkeyButton } from './AddHotkeyButton'
import { AddObservationButton } from './AddObservationButton'
import { EditPointCloudConfigButton } from './EditPointCloudConfigButton'

const MenuContainer = styled.div<{ $isOpen: boolean }>`
  display: flex;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  flex-direction: column;
  align-items: end;
  gap: 8px;
  margin: 20px 10px;
  height: ${({ $isOpen }) => ($isOpen ? '160px' : '70px')};
  transition: height 200ms;
`

interface HudMenuProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

export const HudPlusMenu: FC<HudMenuProps> = (props) => {
  return (
    <MenuContainer $isOpen={props.isOpen}>
      <EditPointCloudConfigButton closeMenu={() => props.setIsOpen(false)} />
      <AddObservationButton closeMenu={() => props.setIsOpen(false)} />
      <AddHotkeyButton closeMenu={() => props.setIsOpen(false)} />
    </MenuContainer>
  )
}
